import { mobileBackendUrl } from '../../../env'
import axiosInstance from '../../../utils/axiosConfig'

export interface UpdateTaxBracketPayload {
  taxBracket: number
}

export async function updateTaxBracket(payload: UpdateTaxBracketPayload): Promise<void> {
  const response = await axiosInstance.post(`${mobileBackendUrl}/v2/tax-harvesting/update-tax-bracket`, payload)
  if (!response?.data) {
    throw new Error('Failed to update tax bracket')
  }
  return response.data
}
